import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    TextInput,
    Tiles,
    Modal,
    Text
} from '@simplybenefits/sb-ui-library';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { assignRepresentative, removeRepresentatives } from '../../../actions/accounts.js';
import permissionLevel from '../../../services/permissions.js';

class Representatives extends Component {
    state = {
        selectedRepresentative: null,
        showRepresentativeForm: false,
        toggleRemoveRepresentative: false,
        representative: null,
        type: null
    };

    _hideForm = () => {
        this.setState({
            showRepresentativeForm: false,
            toggleRemoveRepresentative: false
        });
    };

    _showNewRepresentative = () => {
        this.setState({
            showRepresentativeForm: true,
            selectedRepresentative: null,
            masterID: null,
            type: null
        });
    };

    /**
     * @returns {Promise<void>}
     * @private
     */
    _assignRepresentative = async () => {
        if (!this.state.representative || !this.state.type) {
            return null;
        }

        const success = await this.props.dispatch(assignRepresentative(this.state.representative.masterID, this.state.type, this.props.accountID));

        if (success) {
            this._hideForm();
        }

        return null;
    };

    /**
     * @private
     */
    _removeRepresentative = async () => {
        const success = await this.props.dispatch(removeRepresentatives(this.state.selectedRepresentative, this.props.accountID));

        if (success) {
            this._hideForm();
        }
    };

    _getTiles = () => {
        const writeAccess = permissionLevel('Representatives', this.props.accessType).includes('write');

        let tiles = writeAccess ?
            [{
                title: 'Assign Representative',
                description: 'Add a new representative to the account.',
                onClick: this._showNewRepresentative,
                testid: 'create-or-edit-representatives',
                icon: 'Assign Representative'
            }]
            : [];

        this.props.representatives.assigned.map((item) => {
            tiles.push({
                title: item.name,
                description: item.email,
                icon: 'Person',
                subtitle: item.type,
                onClick: () => {
                    if (writeAccess) {
                        this.setState({
                            toggleRemoveRepresentative: true,
                            selectedRepresentative: item.masterID
                        });
                    }
                }
            });

            return null;
        });

        return tiles;
    };

    render() {
        const writeAccess = permissionLevel('Representatives', this.props.accessType).includes('write');
        const tiles = this._getTiles();

        return (
            <React.Fragment>
                <Tiles tiles={tiles} />

                <Modal
                    testid="add-representative-modal"
                    open={this.state.showRepresentativeForm}
                    onClose={this._hideForm}
                    title="Assign Representative"
                    primaryButton={{
                        onClick: writeAccess ? this._assignRepresentative : false
                    }}
                >
                    <Autocomplete
                        options={ this.props.representatives.available }
                        getOptionLabel={(representative) => representative.name }
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        renderOption={(props, option) => (
                            <li {...props} key={option.masterID}>
                                { option.name }
                            </li>
                        )}
                        value={ this.state.representative }
                        onChange={(event, newValue) => {
                            this.setState({
                                representative: newValue
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Representative"
                                variant="outlined"
                                required
                                fullWidth
                                sx={{ marginTop: '5px' }}
                            />
                        )}
                    />

                    <TextInput
                        label="Type"
                        value={ this.state.type }
                        onChange={(e) => {
                            this.setState({
                                type: e.target.value
                            });
                        }}
                        select
                        selectOptions={[ 'Account Executive', 'Service Representative' ]}
                        fullWidth
                    />
                </Modal>

                <Modal
                    open={ this.state.toggleRemoveRepresentative }
                    onClose={ () => this.setState({ toggleRemoveRepresentative: false })}
                    title="Remove Representative"
                    primaryButton={{
                        label: "Remove Representative",
                        onClick: writeAccess ? this._removeRepresentative : false
                    }}
                    loader={this.props.loader}
                >
                    <Text medium>
                        Are you sure you want to remove this representative from the account?
                    </Text>
                </Modal>

            </React.Fragment>
        );
    }
}

Representatives.propTypes = {
    representatives: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    representatives: state.accounts.currentAccount.representatives,
    currentAccount: state.accounts.currentAccount,
    accessType: state.master.access
});

export default connect(mapStateToProps)(Representatives);